export default "__VITE_ASSET__04d51d99__"